import * as React from 'react'

import { IFiltersPalette } from 'main/util/asset'

import { FilterButton, FormContainer } from './FilterControl.styles'

interface IProps {
  displayForm: boolean
  filterForm: React.ReactNode
  isActive: boolean | null
  label: React.ReactNode
  palette?: IFiltersPalette
  onRequestCloseForm: () => void
  onRequestDisplayForm: () => void
}

export default function FilterControl(props: IProps) {
  const {
    displayForm,
    filterForm,
    isActive,
    label,
    palette,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const [formRect, setFormRect] = React.useState<ClientRect | null>(null)
  const formContainerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    setFormRect(formContainerRef.current ? formContainerRef.current.getBoundingClientRect() : null)
  }, [displayForm])

  // Hack (cam & alex): we're using this logic to position the form popup to the left if it overflows the screen width
  const leftPos =
    formRect && formRect.right > window.innerWidth ? -(formRect.right - window.innerWidth) - 20 : 0

  return (
    <div css={{ position: 'relative' }}>
      <FilterButton
        palette={palette}
        isActive={isActive || displayForm}
        onClick={() => handleOnClick()}
      >
        {label}
      </FilterButton>
      <FormContainer ref={formContainerRef} isHidden={!displayForm} leftPos={leftPos}>
        {filterForm}
      </FormContainer>
    </div>
  )

  function handleOnClick() {
    displayForm ? onRequestCloseForm() : onRequestDisplayForm()
  }
}
